import styled from "styled-components";

export const ContainerNavigate = styled.div`
  width: 100%;
  display: none;
  @media screen and (max-width: 768px) {
    position: sticky;
    top: 0;
    background-color: transparent;
    z-index: 99;
    display: block;
  }
`;

export const TabProfile = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const TabContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .active {
    color: #4b975b;
    border-bottom: 3px solid #4b975b;
    background: rgba(75, 151, 91, 0.05);
    
    p {
      font-weight: 700;
      color: #4b975b;
    }
  }
  
  > div {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6a7b76;
    padding: 14px 8px;
    border-bottom: 3px solid transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    font-family: 'Plus Jakarta Sans', sans-serif;

    &:hover {
      color: #4b975b;
      background: rgba(75, 151, 91, 0.03);
    }

    p {
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 90%;
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.2s ease-in-out;
    }
  }
`;